import React from 'react';

const FieldViewer = ({modifiedObj, unmodifiedObj, property}) => {
    let modifiedValue = null;
    if(modifiedObj)
        modifiedValue = modifiedObj.hasOwnProperty(property) ? modifiedObj[property] : null;
    let unmodifiedValue = null;
    if(unmodifiedObj)
      unmodifiedValue = unmodifiedObj.hasOwnProperty(property) ? unmodifiedObj[property] : null;

    
    return ( 
        <>
        {
                modifiedValue === unmodifiedValue ?
                <span>{modifiedValue}</span>
                :
                <>
                    <span className="line-through">{unmodifiedValue}</span> &nbsp;
                    <span className="text-purple">{modifiedValue}</span>
                </>
            }
        </>
     );
}
 
export default FieldViewer;